import { CandidateLayout } from "@/components/candidate/CandidateLayout";
import { usePageMeta } from "@/hooks/usePageMeta";
import { useIsAdmin } from "@/hooks/useUserRole";
import { AcademyFeatureToggle } from "@/components/admin/AcademyFeatureToggle";
import { AcademyMetricsPanel } from "@/components/admin/AcademyMetricsPanel";
import { AdminModuleManager } from "@/components/practice/AdminModuleManager";
import { ChallengeAdmin } from "@/components/challenges/ChallengeAdmin";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { GraduationCap, BookOpen, Code2, BarChart3 } from "lucide-react";
import { Navigate } from "react-router-dom";

export default function AcademyManager() {
  usePageMeta({
    title: "Gestor Academy - Data Hire Club",
    description: "Gerencie módulos e conteúdo das trilhas do Academy",
    noindex: true,
  });

  const { isAdmin, isLoading } = useIsAdmin();

  if (isLoading) {
    return (
      <CandidateLayout maxWidth="6xl">
        <p className="text-muted-foreground">Carregando...</p>
      </CandidateLayout>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/candidate/dashboard" replace />;
  }

  return (
    <CandidateLayout maxWidth="6xl">
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <GraduationCap className="h-7 w-7 text-primary" />
          <div>
            <h1 className="text-2xl font-bold text-foreground">Gestor Academy</h1>
            <p className="text-sm text-muted-foreground">
              Gerencie módulos e conteúdo das trilhas de estudo
            </p>
          </div>
        </div>

        <AcademyFeatureToggle />

        <Tabs defaultValue="modules" className="w-full">
          <TabsList>
            <TabsTrigger value="modules" className="gap-1.5">
              <BookOpen className="h-4 w-4" />
              Módulos
            </TabsTrigger>
            <TabsTrigger value="challenges" className="gap-1.5">
              <Code2 className="h-4 w-4" />
              Desafios
            </TabsTrigger>
            <TabsTrigger value="metrics" className="gap-1.5">
              <BarChart3 className="h-4 w-4" />
              Métricas
            </TabsTrigger>
          </TabsList>

          <TabsContent value="modules">
            <AdminModuleManager />
          </TabsContent>

          <TabsContent value="challenges">
            <ChallengeAdmin />
          </TabsContent>

          <TabsContent value="metrics">
            <AcademyMetricsPanel />
          </TabsContent>
        </Tabs>
      </div>
    </CandidateLayout>
  );
}

